<template>
    <div class="container queued-booking-page">
        <div class="d-inline-flex align-items-center mb-3">
            <h5 v-html="TEXTS.render('CSO_BOOKING_MANAGEMENT_HEADER')" class="font-weight-bold nowrap mb-0" />
            <button type="button"
                @click="() => refresh()"
                class="ml-3 btn btn-outline w-auto"
                :style="{
                    backgroundColor: MainUISettings.button_color,
                    color: MainUISettings.button_text_color
                }">
                Refresh
            </button>
        </div>
        <div class="residentportal-filter-bar row mb-4">
            <div class="col-lg-2 col-md-4">
                <div class="form-group">
                    <label>Status:</label>
                    <select class="form-control" v-model="filter.status">
                        <option selected="" :value="null">All</option>
                        <option v-for="status in bookingStatus" :key="status" :value="status">
                            {{ status }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-lg-2 col-md-4">
                <div class="form-group">
                    <label>CRN:</label>
                    <div class="input-group mb-2">
                        <input type="text" class="form-control" placeholder="XXX-XXXXXXX" maxlength="11" v-model="searchCRN" />
                        <i
                            v-if="searchCRN && searchCRN.length > 0"
                            role="button"
                            class="icon icon-close pointer"
                            aria-hidden="true"
                            @click="searchCRN = null"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4">
                <div class="form-group">
                    <label>Booking Date:</label>
                    <v-date-picker
                        v-model="range"
                        @input="() => datepicker()"
                        mode="range"
                        is-range
                    >
                        <template #default="{ inputValue, inputEvents }">
                            <div class="d-flex">
                                <input class="form-control" type="text" readonly
                                    v-if="inputValue.start && inputValue.end"
                                    :value="inputValue.start + ' - ' + inputValue.end"
                                    v-on="inputEvents.start" />
                                <input v-else class="form-control" type="text" readonly :value="inputValue"
                                    v-on="inputEvents.start" />
                                <button type="button"
                                    v-if="inputValue"
                                    @click="() => {
                                        filter.bookingDate = {start: null, end: null}
                                        range = {start: null, end: null}
                                    }">
                                    x
                                </button>
                            </div>
                        </template>
                    </v-date-picker>
                </div>
            </div>
            <div class="col-lg-3 col-md-8">
                <div class="form-group">
                    <label>Address:</label>
                    <BookingSearch
                        :dark="true"
                        ref="bookingSearchForm"
                        :isReducedView="true"
                        :clearAfterSelect="false"
                        :showLabel="false"
                        @clearSearch="() => clearSearch()" />
                </div>
            </div>
            <div class="col-lg-2 col-md-4">
                <div class="form-group">
                    <label>Sort by:</label>
                    <select class="form-control" v-model="filter.sortBy">
                        <option v-for="item in sortList" :key="item" :value="item">
                            {{ item }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <p>{{ totalInFilter }} out of {{ total }} queued bookings</p>
        <QueueBookingTable :items="workOrderRecords" @refresh="() => refresh()" ref="queuedTable" />
        <Pagination
            v-if="totalPage > 1"
            :totalPage="totalPage"
            :currentPage="currentPage"
            @changePaginate="(page) => currentPage = page" />
    </div>
</template>
<script>
import helper from "../../../../helper";
import Texts from '../../../../common/utils/Texts';
import WorkOrderRecord from "../../../../common/utils/WorkOrderRecord";
import QueueBookingTable from './QueueBookingTable';
import Pagination from "../../../../common/components/Pagination";
import BookingSearch from "../../../../common/components/BookingSearch";

export default {
    components: {
        QueueBookingTable,
        Pagination,
        BookingSearch,
    },
    data() {
        return {
            delayTime: 0,
            allWoiWasteTypes: [],
            bookingReferenceEntitlementsClaimedHash: {},
            woStatusRanks: [],
            serviceFilter: null,
            showWooStatusReasonDescFreeIndex: -1,
            range: {
                start: null,
                end: null
            },
            filter: {
                status: null,
                bookingDate: {
                    start: null,
                    end: null
                },
                CRN: null,
                addresssId: null,
                sortBy: 'Booking date'
            },
            bookingStatus: [
                'Submitted', 'Pending'
            ],
            sortList: [
                'Booking date', 'Completion date', 'Status', 'CRN', 'FullAddress'
            ],
            currentPage: 1,
            limit: 10,
            searchCRN: ''
        };
    },
    computed: {
        TEXTS: () => Texts,
        MainUISettings() {
            return this.$store.getters["GET_MAIN_UI"];
        },
        bookingSetting() {
            return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
        },
        personalInfo: function () {
            return this.$store.getters.GET_PERSONAL_INFO;
        },
        queuedBookings: function () {
            return this.$store.getters.GET_QUEUED_BOOKINGS
                ? this.$store.getters.GET_QUEUED_BOOKINGS.listing
                : [];
        },
        submitted() {
            return this.$store.getters.GET_QUEUED_BOOKING_SUBMITTED
        },
        isLoading: function () {
            return this.$store.getters.GET_QUEUED_BOOKINGS
                ? (
                    this.$store.getters.GET_QUEUED_BOOKINGS.isLoading ||
                    this.submitted.isLoading
                )
                : false;
        },
        totalInFilter: function () {
            return this.$store.getters.GET_QUEUED_BOOKINGS
                ? this.$store.getters.GET_QUEUED_BOOKINGS.totalInFilter
                : 0;
        },
        total: function () {
            return this.$store.getters.GET_QUEUED_BOOKINGS
                ? this.$store.getters.GET_QUEUED_BOOKINGS.total
                : 0;
        },
        totalPage: function () {
            if(this.$store.getters.GET_QUEUED_BOOKINGS) {
                return Math.ceil(this.totalInFilter / this.limit);
            }

            return 1;
        },
        allWasteStreams() {
            var wasteStreams = this.$store.getters.GET_ALL_WASTE_STREAMS;
            return wasteStreams.list;
        },
        woiWasteTypes() {
            var wasteStreams = this.$store.getters.GET_WOI_WASTE.list;
            return wasteStreams.list;
        },
        allServices() {
            return this.$store.getters.GET_SERVICES.list;
        },
        allWasteStreamCombos() {
            return this.$store.getters.GET_WASTE_COMBO_LIST.list;
        },
        workOrderRecords: function () {
            var queuedBookings = this.queuedBookings;
            var workOrderRecords = {};

            // Prevent Null Exceptions
            if (!queuedBookings || queuedBookings.length < 0) {
                return workOrderRecords;
            }
            
            // Group the work orders by CRN
            var historyDetails = this.groupWorkOrders(queuedBookings);
            // Iterate over each entry
            for (var key in historyDetails) {
                var workOrder = historyDetails[key];

                // Find a Matching Service Waste Stream
                var displayNames = this.findWorkOrderDisplayNames(workOrder);
                // Format workOrder
                var workOrderRecord = new WorkOrderRecord({
                    ...workOrder,
                    woServiceType: workOrder.WOServiceType,
                    woWasteType: workOrder.WOWasteType,
                    formatCRN: this.formatCrnForPrint(workOrder.CRN),
                    displayDate: helper.getFormattedDate(workOrder.RequestedCompletionDate),
                    bookingDate: helper.getFormattedDate(workOrder.BookingSubmissionDatetime)
                }, displayNames);
                workOrderRecords[key] = workOrderRecord;
            }

            return workOrderRecords;
        },
        serviceWasteStreamHash() {
            var hash = [];

            if (this.allServices && this.allWasteStreams) {
                var services = this.allServices;
                var wasteStreams = this.allWasteStreams;
                var wasteStreamCombos = this.allWasteStreamCombos;

                for (let i = 0; i < services.length; i++) {
                    services[i].wasteStreams = [];
                    services[i].wasteStreamCombos = [];
                    for (let j = 0; j < wasteStreams.length; j++) {
                        if (
                            services[i].service_setting_id ==
                            wasteStreams[j].service_setting_id
                        ) {
                            services[i].wasteStreams.push(wasteStreams[j]);
                        }
                    }
                    for (let j = 0; j < wasteStreamCombos.length; j++) {
                        if (
                            services[i].service_setting_id ==
                            wasteStreamCombos[j].service_setting_id
                        ) {
                            services[i].wasteStreamCombos.push(wasteStreamCombos[j]);
                        }
                    }
                }

                var servicesHash = [];

                for (let i = 0; i < services.length; i++) {
                    var condensedService = {
                        service_setting_id: services[i].service_setting_id,
                        service_name: services[i].service_name,
                        api_value: services[i].api_value,

                        // Date Selection Values
                        date_selection: services[i].date_selection,
                        weekly_start_day: services[i].weekly_start_day,

                        wasteStreams: [],
                        wasteStreamCombos: [],
                    };
                    services[i].wasteStreams.forEach((wasteStream) => {
                        condensedService.wasteStreams.push({
                            waste_stream_setting_id: wasteStream.waste_stream_setting_id,
                            waste_stream_name: wasteStream.waste_stream_name,
                            api_value: wasteStream.api_value,
                            is_hidden: !wasteStream.is_cso && !wasteStream.is_res,
                        });
                    });
                    services[i].wasteStreamCombos.forEach((wasteStreamCombo) => {
                        var primary_waste_stream = wasteStreamCombo.primary_waste_stream;
                        condensedService.wasteStreamCombos.push({
                            primary_waste_stream_setting_id:
                                primary_waste_stream.waste_stream_setting_id,
                            primary_waste_stream_name: primary_waste_stream.waste_stream_name,
                            primary_waste_stream_api_value: primary_waste_stream.api_value,
                            api_value: wasteStreamCombo.api_value,
                        });
                    });

                    servicesHash.push(condensedService);
                }

                servicesHash = servicesHash.sort((a, b) => {
                    var textA = a.api_value.toUpperCase();
                    var textB = b.api_value.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });

                hash = servicesHash;
            }

            return hash;
        },
        activeAddress() {
            return this.$store.getters.GET_ACTIVE_ADDRESS
        },
    },
    async mounted() {
        // this.$store.dispatch("getGSTData");
        await this.$store.dispatch("getServices");
        if(
            (this.bookingSetting && !this.bookingSetting.enable_queue_booking) ||
            (this.personalInfo && this.personalInfo.type != 'cso')
        ) {
            this.$router.push({ path: '/booking/home' });
            return;
        }
        this.$store.dispatch("getAllWasteStreams");
        this.$store.dispatch("getWasteComboList");
        this.$store.dispatch("getAllWoiWasteType").then((data) => this.allWoiWasteTypes = data);
        this.$store.dispatch("getWoStatusRank").then((data) => {
            // -- Format as array
            var list = data ? data.list : null;
            if (list && Array.isArray(list)) {
                list = list.sort((a, b) => a.rank - b.rank);
                this.woStatusRanks = list.map((statusRank) => statusRank.status);
            }
        });
        await this.getQueuedBookings(false);
    },
    methods: {
        getPaidStatus(serviceName) {
            for (let i = 0; i < this.$store.getters.GET_SERVICES.list.length; i++) {
                if (
                    this.$store.getters.GET_SERVICES.list[i].api_value.toLowerCase() ==
                    serviceName.toLowerCase()
                ) {
                    return this.$store.getters.GET_SERVICES.list[i].is_paid;
                }
            }
        },
        groupWorkOrders(workOrders) {
            if(!workOrders)
                return {};

            let workOrderGroups = {};
            workOrders.forEach((workOrder) => {
                var orderKey = `${workOrder.CRN}-${workOrder.WOServiceType}`;

                if (!workOrderGroups[orderKey]) {
                    workOrderGroups[orderKey] = {
                        ...workOrder,
                    };
                    workOrderGroups[orderKey].woEntitlement = parseInt(
                        workOrder.Entitlement
                    );
                    workOrderGroups[orderKey].woAmountPaid = parseFloat(
                        workOrder.woAmountPaid
                    );
                    workOrderGroups[orderKey].isPaid = this.getPaidStatus(
                        workOrder.WOServiceType
                    );
                    workOrderGroups[orderKey].orders = [workOrder];
                } else {
                    const foundGroup = workOrderGroups[orderKey];

                    foundGroup.woEntitlement += parseInt(workOrder.Entitlement);
                    foundGroup.woAmountPaid += parseFloat(workOrder.woAmountPaid);
                    foundGroup.orders.push(workOrder);
                }
                
                if (workOrder.WOIWasteType && workOrder.WOIWasteType != "") {
                    workOrder.hasWoi = true;
                    workOrderGroups[orderKey].hasWoi = true;
                }

                // --- Display Date
                var createDate =
                    workOrder.RequestedCompletionDate != ""
                        ? workOrder.RequestedCompletionDate
                        : null;
                var scheduleDate =
                    workOrder.woScheduledDateTime != ""
                        ? workOrder.woScheduledDateTime
                        : null;
                var completeDate =
                    workOrder.RequestedCompletionDate != ""
                        ? workOrder.RequestedCompletionDate
                        : null;

                // Safari-Friendly Selection
                var displayDate;
                if (completeDate) {
                    displayDate = completeDate;
                } else if (scheduleDate) {
                    displayDate = scheduleDate;
                } else if (createDate) {
                    displayDate = createDate;
                }

                if (!workOrderGroups[orderKey].displayDate) {
                    workOrderGroups[orderKey].displayDate = displayDate;
                } else {
                    var origDate = new Date(
                        this.toSafariDate(workOrderGroups[orderKey].displayDate)
                    );
                    var newDate = new Date(this.toSafariDate(displayDate));

                    workOrderGroups[orderKey].displayDate =
                        origDate.getTime() > newDate.getTime()
                            ? workOrderGroups[orderKey].displayDate
                            : displayDate;
                }
            });

            // --- Determin ranked status
            for (var key in workOrderGroups) {
                var rankedStatus = null;
                for (let i = 0; i < this.woStatusRanks.length; i++) {
                    const status = this.woStatusRanks[i] ? this.woStatusRanks[i].toLowerCase().trim() : null;
                    for (let j = 0; j < workOrderGroups[key].orders.length; j++) {
                        const order = workOrderGroups[key].orders[j];
                        const orderWoStatus = typeof order.woStatus == "string" ? order.woStatus.toLowerCase().trim() : null
                        if (status === orderWoStatus) {
                            rankedStatus = order.woStatus;
                            break;
                        }
                    }
                    if (rankedStatus) {
                        break;
                    }
                }
                if (!rankedStatus) {
                    rankedStatus = workOrderGroups[key].woStatus;
                }
                workOrderGroups[key].rankedStatus = rankedStatus;
            }

            return workOrderGroups;
        },
        findWorkOrderDisplayNames(workOrder) {
            var displayNames = {};

            if (!this.serviceWasteStreamHash) {
                return displayNames;
            }

            var WOServiceTypeTrimmed = workOrder.WOServiceType
                ? workOrder.WOServiceType.toLowerCase().trim()
                : "";
            for (let i = 0; i < this.serviceWasteStreamHash.length; i++) {
                const serviceHash = this.serviceWasteStreamHash[i];
                // Condition One: WorkerOrder's WOServiceType matches service's api value
                var serviceApiTrimmed = serviceHash.api_value
                    ? serviceHash.api_value.toLowerCase().trim()
                    : "";
                if (WOServiceTypeTrimmed != serviceApiTrimmed) {
                    continue;
                }

                // Condition Two: All of the Waste WOWasteTypes in the Work Order are found under the service
                var orders = workOrder.orders;
                var allWasteTypesMatched = true;
                for (let j = 0; j < orders.length; j++) {
                    var WOWasteType = orders[j].WOWasteType;
                    var WOWasteTypeTrimmed = WOWasteType
                        ? WOWasteType.toLowerCase().trim()
                        : "";

                    // Check and see if it's a WasteStreamCombo
                    var matchingWasteStreamCombo = serviceHash.wasteStreamCombos.find(
                        (wasteStreamCombo) => {
                            var wasteStreamComboTrimmed = wasteStreamCombo.api_value
                                ? wasteStreamCombo.api_value.toLowerCase().trim()
                                : "";
                            return WOWasteTypeTrimmed == wasteStreamComboTrimmed;
                        }
                    );
                    if (matchingWasteStreamCombo) {
                        WOWasteType =
                            matchingWasteStreamCombo.primary_waste_stream_api_value;
                        WOWasteTypeTrimmed = WOWasteType
                            ? WOWasteType.toLowerCase().trim()
                            : "";
                    }

                    var matchingWasteStream = serviceHash.wasteStreams.find(
                        (wasteStream) => {
                            var wasteStreamTrimmed = wasteStream.api_value
                                ? wasteStream.api_value.toLowerCase().trim()
                                : "";
                            return WOWasteTypeTrimmed == wasteStreamTrimmed;
                        }
                    );
                    if (!matchingWasteStream) {
                        allWasteTypesMatched = false;
                        break;
                    }
                }

                if (allWasteTypesMatched) {
                    displayNames = serviceHash;
                    break;
                }
            }

            return displayNames;
        },
        toSafariDate(date) {
            if (typeof date == "object")
                return (
                    date.getUTCFullYear() +
                    "-" +
                    (date.getUTCMonth() + 1) +
                    "-" +
                    date.getUTCDate()
                );
            else return date;
        },
        formatCrnForPrint(crnString) {
            if (typeof crnString == "string" &&
                crnString.toLowerCase().indexOf('crn') == -1 &&
                crnString.toLowerCase().indexOf('ent') == -1 &&
                crnString.toLowerCase().indexOf('cwo') == -1
            ) {

                return `CRN${crnString}`;
            }
            else {
                return crnString
            }
        },
        convertDate(date) {
            if(date && typeof date == 'object') {
                return (
                    date.getFullYear() +
                    "-" +
                    (date.getMonth() + 1) +
                    "-" +
                    date.getDate()
                );
            }

            return date;
        },
        getQueuedBookings(loading = true) {
            if(loading)
                $('#pageLoadingModal').modal('show');

            this.$store.dispatch("getQueuedBookings", {
                limit: this.limit,
                offset: (parseInt(this.currentPage) - 1) * this.limit,
                ...this.filter,
                bookingDate: {
                    start: this.filter.bookingDate.start ? this.convertDate(this.filter.bookingDate.start) : null,
                    end: this.filter.bookingDate.end ? this.convertDate(this.filter.bookingDate.end) : null
                }
            });
        },
        clearSearch() {
            this.filter = {
                ...this.filter,
                addresssId: null
            }
        },
        async refresh() {
            await this.$refs.queuedTable.closedQueueBooking();
            this.$refs.bookingSearchForm.clearSearchString();
            this.currentPage = 1; // Reset to page 1
            //Reset all filter params
            this.filter = {
                status: null,
                bookingDate: {
                    start: null,
                    end: null
                },
                CRN: null,
                addresssId: null,
                sortBy: 'Booking date'
            }
            this.searchCRN = ''
            this.range = {
                start: null,
                end: null
            }
        },
        datepicker() {
            if(this.range && this.range.start && this.range.end) {
                this.filter.bookingDate = this.range;
            }
        }
    },
    watch: {
        bookingSetting(val) {
            if(val && !val.enable_queue_booking) {
                $('#pageLoadingModal').modal('hide');
                this.$router.push({ path: '/booking/home' });
                return;
            }
        },
        personalInfo(val) {
            if(val && val.type != 'cso') {
                $('#pageLoadingModal').modal('hide');
                this.$router.push({ path: '/booking/home' });
                return;
            }
        },
        currentPage(val) {
            if(val && val > 0)
                this.getQueuedBookings();
        },
        filter: {
            handler: async function() {
                if(this.currentPage == 1) {
                    this.getQueuedBookings();
                } else {
                    this.currentPage = 1;
                }
            },
            deep: true
        },
        isLoading(val) {
            if(val) {
                $('#pageLoadingModal').modal('show')
            } else {
                $('#pageLoadingModal').modal('hide')
            }
        },
        activeAddress(val) {
            clearTimeout(this.delayTime);

            this.delayTime = setTimeout(() => {
                this.filter = {
                    ...this.filter,
                    addresssId: (val && val.id) ? val.id : null
                }
            }, 1000)
        },
        searchCRN(val) {
            if(val && val.length != 11 && val != '') {
                return;
            }

            clearTimeout(this.delayTime);

            this.delayTime = setTimeout(() => {
                this.filter = {
                    ...this.filter,
                    CRN: val
                }
            }, 300)
        }
    }
}
</script>